export const STORE_EASY_ACCESS_TOKEN = 'STORE_EASY_ACCESS_TOKEN'

export const storeEasyAccessToken = (token: string) => ({
  type: STORE_EASY_ACCESS_TOKEN,
  token,
})
